import { World } from "./testCase";
import { InterceptTestCase } from "./interceptTestCase";
class InterceptGetBoatXRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._intercepTestCase = testCase;
    }
    setHookDepth(depth) {
        this._intercepTestCase.setHookDepth(depth);
    }
    getBoatX() {
        return this._intercepTestCase.getBoatX();
    }
}
export class InterceptGetBoatXTestCase extends InterceptTestCase {
    getBoatX() {
        this.log("Boat X is " + this._boatX);
        return this._boatX;
    }
    constructor(parameterData) {
        super(parameterData);
    }
    //This is the "world" argument that users code against.
    createRoot() {
        return new InterceptGetBoatXRoot(this);
    }
    createElement(document) {
        let template = document.createElement("template");
        let html = `
    <div class="intercept-container">
      <div>
        <div class="intercept-center">
          <button class="get_boat_x_button w-full btn-darkBackHigh">Get Boat X</button>
        </div>
        <div class="intercept-center">
          <input type="number" readonly="true" class="get_boat_x_value intercept_value w-full bg-darkBack text-darkFore outline-none" min="-9" max="9" value="0">
        </div>
        <div class="intercept-center">
          <input type="number" class="depth_value intercept_value w-full bg-darkBack text-darkFore outline-none" min="0" max="9">
        </div>
        <div class="intercept-center">
          <button class="depth_submit w-full btn-darkBackHigh">Set Hook Depth</button>
        </div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        //Get Boat X
        let boatX = template.content.firstElementChild
            .getElementsByClassName("get_boat_x_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("get_boat_x_button")[0]
            .addEventListener("click", () => {
            boatX.value = this.getBoatX().toString();
        });
        //Hook Depth
        let inputElement = template.content.firstElementChild.getElementsByClassName("depth_value")[0];
        let buttonElement = template.content.firstElementChild.getElementsByClassName("depth_submit")[0];
        buttonElement.addEventListener("click", () => {
            let depthText = inputElement.value;
            let depth = Number(depthText) || 0; //TODO: We should have some error handling for bad numbers?
            this.setHookDepth(depth);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
}
